import { Promise } from "es6-promise-polyfill"

export default function(wrapped)
{
    return new Promise(function (resolve, reject)
    {
        try
        {
            wrapped(function () {
                resolve(Array.prototype.slice.call(arguments));
            });
        }
        catch(e)
        {
            reject(e);
        }
    });
}



// WEBPACK FOOTER //
// ./src/util/callback.js